/**
 * Personal data some email links carry in the query. Analytics, Sentry and
 * Hotjar keep the full URL, so these are read and dropped from the address bar
 * before any of them boots: main.tsx imports this module first.
 */
const PRIVATE_PARAMS = ["mail"] as const;

type PrivateParam = (typeof PRIVATE_PARAMS)[number];

// A reload no longer has them in the URL: the tab keeps them for that same link.
const STORAGE_KEY = "privateParams";

export const privateParams: Partial<Record<PrivateParam, string>> = {};

let search = window.location.search;
for (const key of PRIVATE_PARAMS) {
  // Cut out raw: re-serializing would mangle an unencoded razón social with "&".
  const match = new RegExp(`([?&])${key}=([^&]*)&?`).exec(search);
  if (!match) continue;

  try {
    // Not URLSearchParams: Postmark doesn't encode, and a "+" in an address
    // would come back as a space.
    privateParams[key] = decodeURIComponent(match[2]).trim();
  } catch {
    privateParams[key] = match[2].trim();
  }
  search = search.replace(match[0], match[1]).replace(/[?&]$/, "");
}

try {
  if (search !== window.location.search) {
    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ search, params: privateParams }),
    );
  } else {
    const stored = JSON.parse(sessionStorage.getItem(STORAGE_KEY) ?? "null");
    if (stored?.search === search) Object.assign(privateParams, stored.params);
  }
} catch {
  // Storage blocked: a reload just loses them.
}

if (search !== window.location.search)
  window.history.replaceState(
    window.history.state,
    "",
    `${window.location.pathname}${search}${window.location.hash}`,
  );
